<template>
     <el-dialog :visible.sync="unfrozenDialog" width="50%" top="15vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
        <el-card>
            <el-table :data="response.data"
                style="margin:auto;width:calc(100% - 30px)" height="300" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
            <el-table-column label="商户主键" align="center" prop="bsId"></el-table-column>
            <el-table-column label="冻结金额" align="center" prop="stateStr">
                 <template slot-scope="scope">{{scope.row.money / 100}}</template>
            </el-table-column>
            <el-table-column label="冻结原因" align="center">
                <template slot-scope="scope">{{scope.row.reason}}</template>
            </el-table-column>
            <el-table-column label="冻结时间" align="center">
                <template slot-scope="scope">{{scope.row.createTime | formatDate}}</template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="warning" plain size="small" @click="unFrozen(scope.row.id)">解冻</el-button>
                </template>
            </el-table-column>
            </el-table>
        </el-card>
     </el-dialog>
</template>
<script>
import {getFrozen} from '../../../api/accountFunds/bsfundsdetail.js'
import {thawBalance} from '../../../api/accountFunds/csfunddetail.js'
import { formatDate } from "../../../utils/date";
export default {
    data() {
        return {
            unfrozenDialog: false,
            response: {data: []},
            loading: false,
            id: ''
        }
    },
    methods: {
        init(id){
            this.unfrozenDialog = true;
            this.id = id;
            getFrozen(id).then(result=>{
                this.response.data = result.data;
            })
        },

        /**
         * 解冻余额
         */
        unFrozen(id){
            thawBalance(id).then(result=>{
                if(result.code === "000000"){
                    this.$emit("unfrozen-succeed");
                    this.$message({
                        type: 'success',
                        message: '操作成功!'
                    });
                    this.init(this.id);
                }
            })
        }
    },
    filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd hh:mm:ss");
        },
    },
}
</script>
<style scoped>
.el-pagination{
    margin-left: 30%;
}
</style>


// WEBPACK FOOTER //
// src/pages/finance/fundsaccount/bsunfrozenmoney.vue